<template>
  <div :class="[$style['target-wrap'], $style.pageContent]">
    <div class="isStylePageContent">
      <h4 class="form-block-title">
        適用對象
        <div class="btn">
          <el-button v-if="seeList" class="is-round" @click="changePage(2)">查看名單</el-button>
        </div>
      </h4>
      <el-row type="flex">
        <el-col :span="24" :md="11">
          <h5 style="margin-top: 0;">
            <BaseIcon icon-style="fal" name="user-check"></BaseIcon>
            加入適用對象
          </h5>
          <p style="li">請加入適用的標籤群組。</p>
          <p>若無設定則所有客戶皆為此優惠代碼發送的目標。</p>
          <el-input v-model="searchIncludeTag" class="search" placeholder="搜尋標籤群組" clearable>
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
          <div class="target-box">
            <el-checkbox v-model="includeCheckAll" class="check-all" :indeterminate="isIndeterminate" :disabled="submitData.excludeTag.length === tagList.length" @change="handleIncludeCheckAllChange">
              全選
            </el-checkbox>
            <el-checkbox-group v-model="submitData.includeTag" class="tag" @change="handleCheckedIncludeTagChange">
              <el-checkbox v-for="(tag, index) in filterIncludeTags" :key="`tag-${index}`" :label="tag.id" :disabled="submitData.excludeTag.includes(tag.id)" border>
                {{ tag.title }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <h5>指定客戶</h5>
          <el-autocomplete
            ref="includeMember"
            v-model="includeMemberSearch.queryString"
            class="search"
            :fetch-suggestions="fetchIncludeSuggestions"
            placeholder="搜尋客戶"
            popper-class="include-suggestion-dropdown"
            @select="handleSelectIncludeMember"
          >
            <template id="clientSearch" v-slot="{ item }">
              {{ `${item.fullName}・${item.phoneNumber}` }}
            </template>
          </el-autocomplete>
          <div class="target-box selected-member">
            <div class="header">客戶姓名 / 電話</div>
            <div class="content">
              <div v-for="(member, index) in submitData.includeMember" :key="`includeMember-${index}`" class="item">
                <div>{{ member.fullName }} {{ member.phoneNumber || member.phone }}</div>
                <el-button type="text" @click="handleRemoveMember(index)">
                  <BaseIcon name="times" icon-style="fal"></BaseIcon>
                </el-button>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="2" :class="$style['vertical-divider']"> </el-col>

        <el-col :span="24" :md="11">
          <h5 style="margin-top: 0;">
            <BaseIcon icon-style="fal" name="user-times"> </BaseIcon>
            排除特定的對象
          </h5>
          <p>請選取要特別排除的標籤群組與人，如：黑名單。</p>
          <p style="color: #E35D5D;">若選取對象和適用對象重複，會以排除對象為主。</p>
          <el-input v-model="searchExcludeTag" class="search" placeholder="搜尋標籤群組" clearable>
            <BaseIcon slot="suffix" name="search" class="el-input__icon" />
          </el-input>
          <div class="target-box">
            <el-checkbox
              v-model="excludeCheckAll"
              class="check-all"
              :indeterminate="isExcludeIndeterminate"
              :disabled="submitData.includeTag.length === tagList.length"
              @change="handleExcludeCheckAllChange"
            >
              全選
            </el-checkbox>
            <el-checkbox-group v-model="submitData.excludeTag" class="tag" @change="handleCheckedExcludeTagChange">
              <el-checkbox v-for="(tag, index) in filterExcludeTags" :key="`tag-${index}`" :label="tag.id" :disabled="submitData.includeTag.includes(tag.id)" border>
                {{ tag.title }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <h5>排除客戶</h5>
          <el-autocomplete
            ref="excludeMember"
            v-model="excludeMemberSearch.queryString"
            class="search"
            :fetch-suggestions="fetchExcludeSuggestions"
            placeholder="搜尋客戶"
            popper-class="exclude-suggestion-dropdown"
            @select="handleSelectExcludeMember"
          >
            <template id="clientSearch" v-slot="{ item }">
              {{ `${item.fullName}・${item.phoneNumber}` }}
            </template>
          </el-autocomplete>
          <div class="target-box selected-member">
            <div class="header">客戶姓名 / 電話</div>
            <div class="content">
              <div v-for="(member, index) in submitData.excludeMember" :key="`excludeMember-${index}`" class="item">
                <div>{{ member.fullName }} {{ member.phoneNumber || member.phone }}</div>
                <el-button type="text" @click="handleRemoveMember(index, 'exclude')">
                  <BaseIcon name="times" icon-style="fal"></BaseIcon>
                </el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<!-- eslint-disable camelcase -->
<!-- eslint-disable standard/no-callback-literal -->
<script>
import { throttle } from 'lodash'

const initData = {
  availableTags: [],
  blockTags: [],
  availableMembers: [],
  blockMembers: [],
  includeTag: [],
  excludeTag: [],
  includeMember: [],
  excludeMember: [],
}

export default {
  name: 'CouponTarget',
  components: {},
  filters: {},
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    const { availableTags, blockTags, availableMembers, blockMembers, ...restDefaultValue } = Object.assign({}, initData, this.defaultValue)
    return {
      tryingStore: false,
      searchIncludeTag: '',
      searchExcludeTag: '',
      searchExcludeMember: '',
      submitData: {
        ...restDefaultValue,
        includeTag: [...availableTags.map((tag) => tag.id)],
        excludeTag: [...blockTags.map((tag) => tag.id)],
        includeMember: [...availableMembers],
        excludeMember: [...blockMembers],
      },
      tagList: [],

      // 標籤適用排除對象
      includeMemberList: [],
      excludeMemberList: [],
      includeCheckAll: false,
      excludeCheckAll: false,
      isIndeterminate: false,
      isExcludeIndeterminate: false,

      includeMemberSearch: {
        queryString: '',
        next_cursor: '',
      },

      excludeMemberSearch: {
        queryString: '',
        next_cursor: '',
      },
    }
  },

  computed: {
    checkedIncludeTagsIds() {
      return this.tagList.filter((optopn) => this.submitData.includeTag.some((checked) => checked === optopn.id))
    },

    checkedExcludeTagsIds() {
      return this.tagList.filter((optopn) => this.submitData.excludeTag.some((checked) => checked === optopn.id))
    },

    filterIncludeTags() {
      if (this.searchIncludeTag === '') return this.tagList
      return this.tagList.filter((tag) => {
        return tag.title.includes(this.searchIncludeTag)
      })
    },

    filterExcludeTags() {
      if (this.searchExcludeTag === '') return this.tagList
      return this.tagList.filter((tag) => {
        return tag.title.includes(this.searchExcludeTag)
      })
    },

    filterSubmitData() {
      const { includeTag, excludeTag, includeMember, excludeMember } = this.submitData
      const includeTags = includeTag.map((id) => ({ id, block: 0 }))
      const excludeTags = excludeTag.map((id) => ({ id, block: 1 }))
      const includeMembers = includeMember.map((member) => ({ id: member.id, block: 0 }))
      const excludeMembers = excludeMember.map((member) => ({ id: member.id, block: 1 }))
      return {
        tags: [...includeTags, ...excludeTags],
        members: [...includeMembers, ...excludeMembers],
      }
    },
    /**
     * @description 如果是新增，則查看名單就不要顯現
     */
    seeList() {
      if (this.$route.path.includes('/coupon/add')) {
        return false
      }
      return true
    },
  },

  watch: {
    checkedIncludeTagsIds: {
      handler(val) {
        this.$set(this.submitData, 'includeTag', this.submitData.includeTag)
      },
      deep: true,
      immediate: true,
    },
    checkedExcludeTagsIds: {
      handler(val) {
        this.$set(this.submitData, 'excludeTag', this.submitData.excludeTag)
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.fetchTags()
  },

  mounted() {
    this.infiniteScroll()
  },

  methods: {
    infiniteScroll() {
      const includeScrollBar = document.querySelector('.include-suggestion-dropdown .el-scrollbar__wrap')
      const excludeScrollBar = document.querySelector('.exclude-suggestion-dropdown .el-scrollbar__wrap')
      const includeMember = this.$refs.includeMember
      const excludeMember = this.$refs.excludeMember
      const throttleLoadMoreIncludeSuggestions = throttle(this.loadMoreIncludeSuggestions, 1000, { trailing: false })
      const throttleLoadMoreExcludeSuggestions = throttle(this.loadMoreExcludeSuggestions, 1000, { trailing: false })

      const includeHandler = () => {
        // 如果滾輪高度 + offset > 總高度，就載更多客戶
        if (includeScrollBar.scrollTop + 300 > includeMember.$data?.suggestions.length * 34 + 20 && this.includeMemberSearch.next_cursor) {
          throttleLoadMoreIncludeSuggestions()
        }
      }
      const excludeHandler = () => {
        // 如果滾輪高度 + offset > 總高度，就載更多客戶
        if (excludeScrollBar.scrollTop + 300 > excludeMember.$data?.suggestions.length * 34 + 20 && this.excludeMemberSearch.next_cursor) {
          throttleLoadMoreExcludeSuggestions()
        }
      }

      includeScrollBar.addEventListener('scroll', includeHandler)
      excludeScrollBar.addEventListener('scroll', excludeHandler)
    },

    async fetchTags() {
      this.tagList = await this.$store.dispatch('member/fetchTags', {
        search: '',
      })
    },

    async fetchMember(keyword = '', next_cursor = '') {
      let searchObj = {
        search: keyword,
        cursorPaginate: 1,
        next_cursor,
      }
      const res = await this.$store.dispatch('member/fetchListByKeyword', searchObj)
      return { list: res.items, next_cursor: res.pagination.next_cursor }
    },

    async searchMember(queryString, cb, type = 'include') {
      if (!queryString) {
        cb([])
        return
      }

      const { list, next_cursor } = await this.fetchMember(queryString)
      this[`${type}MemberSearch`].next_cursor = next_cursor
      const memberIds = this.submitData[`${type}Member`].map((member) => member.id)
      const oppositeIds = this.submitData[`${type === 'include' ? 'exclude' : 'include'}Member`].map((member) => member.id)
      const filteredList = list.filter((item) => !memberIds.includes(item.id) && !oppositeIds.includes(item.id))
      cb(filteredList)
    },

    fetchIncludeSuggestions(queryString, cb) {
      this.searchMember(queryString, cb, 'include')
    },

    fetchExcludeSuggestions(queryString, cb) {
      this.searchMember(queryString, cb, 'exclude')
    },

    loadMoreIncludeSuggestions() {
      this.loadMoreSuggestions('include')
    },

    loadMoreExcludeSuggestions() {
      this.loadMoreSuggestions('exclude')
    },

    async loadMoreSuggestions(type) {
      if (type === 'include') {
        const { list, next_cursor } = await this.fetchMember(this.includeMemberSearch.queryString, this.includeMemberSearch.next_cursor)
        const filteredList = this.filterSuggestions(list, type)
        this.includeMemberSearch.next_cursor = next_cursor
        this.$refs.includeMember.suggestions.push(...filteredList)
      } else if (type === 'exclude') {
        // console.log('cool test')
        const { list, next_cursor } = await this.fetchMember(this.excludeMemberSearch.queryString, this.excludeMemberSearch.next_cursor)
        const filteredList = this.filterSuggestions(list, type)
        this.excludeMemberSearch.next_cursor = next_cursor
        this.$refs.excludeMember.suggestions.push(...filteredList)
      }
    },

    filterSuggestions(list, type) {
      const memberIds = this.submitData[`${type}Member`].map((member) => member.id)
      const oppositeIds = this.submitData[`${type === 'include' ? 'exclude' : 'include'}Member`].map((member) => member.id)
      const filteredList = list.filter((item) => !memberIds.includes(item.id) && !oppositeIds.includes(item.id))
      return filteredList
    },

    handleSelectMember(member, type = 'include') {
      const isExist = this.submitData[`${type}Member`].some((item) => item.id === member.id)
      if (!isExist) this.submitData[`${type}Member`].push(member)
    },

    handleSelectIncludeMember(member) {
      this.handleSelectMember(member)
    },

    handleSelectExcludeMember(member) {
      this.handleSelectMember(member, 'exclude')
    },

    handleRemoveMember(index, type = 'include') {
      this.submitData[`${type}Member`].splice(index, 1)
    },

    // 適用全選
    handleIncludeCheckAllChange(checked) {
      this.submitData.includeTag = checked ? this.tagList.filter((tag) => !this.submitData.excludeTag.includes(tag.id)).map((price) => price.id) : []
      this.isIndeterminate = false
    },

    // 排除全選
    handleExcludeCheckAllChange(checked) {
      this.submitData.excludeTag = checked ? this.tagList.filter((tag) => !this.submitData.includeTag.includes(tag.id)).map((price) => price.id) : []
      this.isExcludeIndeterminate = false
    },

    handleCheckedIncludeTagChange(value) {
      let checkedCount = value.length
      this.includeCheckAll = checkedCount === this.tagList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tagList.length
      // return this.submitData.includeTag.length > 0 && this.submitData.includeTag.length < this.tagList.length
    },

    handleCheckedExcludeTagChange(value) {
      let checkedCount = value.length
      this.excludeCheckAll = checkedCount === this.tagList.length
      this.isExcludeIndeterminate = checkedCount > 0 && checkedCount < this.tagList.length
    },

    changePage(val) {
      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

:global() {
  :local(.vertical-divider) {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      top: 0;
      left: 50%;
      width: 2px;
      background: #eeeeea;
      transform: translateX(-50%);
    }
  }
}

.target-wrap {
  margin-bottom: 40px;

  :global {
    h5 {
      svg.svg-inline--fa {
        width: 1.3em;
      }
    }

    .search {
      width: 100%;
      margin-bottom: 10px;
    }

    .check-all {
      display: block;
      padding: 14px 17px;
      background: #e5e7eb;
      border-color: $color-line;
      border-bottom: none;
      height: 44px;

      &.is-bordered.is-disabled {
        border-color: $color-line;
      }
    }

    .target-box {
      border: 1px solid $color-line;
      border-radius: 8px;
      overflow: hidden;
      padding-bottom: 14px;
      margin-bottom: 2rem;
    }

    .tag {
      height: 295px;
      overflow-y: auto;
      // border: 1px solid #c6c6ba;
      border-top: 0;

      .el-checkbox {
        display: block;
        padding: 12px;
        margin: 0;

        &.is-disabled {
          background: $color-line;
          cursor: not-allowed;
        }

        margin-left: 18px;
        margin-right: 18px;
        margin-top: 14px;
        height: 44px;
      }

      .el-checkbox + .el-checkbox {
        margin-left: 18px;
        margin-right: 18px;
      }
    }

    .selected-member {
      border: 1px solid $color-line;
      margin-bottom: 40px;

      .header {
        color: $color-text-light;
        padding: 14px 17px;
        background: #e5e7eb;
        height: 44px;
      }

      .content {
        height: 259px;
        overflow-y: auto;
        padding: 14px 18px;

        .item {
          display: flex;
          justify-content: space-between;
          padding: 15px 17px;
          color: $color-secondary;
          height: 44px;
          border-radius: 8px;
          border: 1px solid $color-line;

          .el-button {
            color: $color-secondary;
            padding: 0;
            transform: scale(1.2);
            font-weight: 400;
            height: auto;
          }

          :first-child {
            margin-top: 0;
          }

          &:not(:last-child) {
            margin-top: 14px;
          }

          & + .item {
            // border-top: 1px solid #eeeeea;
          }

          &:last-child {
            // border-bottom: 1px solid #eeeeea;
          }
        }
      }
    }
  }
}
</style>
